import { Typography } from "@mui/material";

import { TCustomCellComponent } from "./types";

import { getValue } from ".";

export const UnknownCell: TCustomCellComponent = ({ attribute, user }) => {
  return <Typography>{getValue(user, attribute)}</Typography>;
};
